export default (params) => ({
  trigger: {
    name: 'content_blocks.comparison.select_item_in_item_card',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
        ],
      },
      item_id: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
